import React from "react";

import { Accordion } from "@mantine/core";
import _ from "lodash";

import { TitleExplorerCompanyRollup } from "lib/frontend/benchmarking/types";

import { CompanyRangePercentile } from "../CompanyRangePercentile";
import { ExplorerResultsEntryAccordion } from "../ExplorerResultsAccordion";
import { PostGeonameLink } from "../PostGeonameLink";

interface TitlePageResultsAccordionProps {
  results: TitleExplorerCompanyRollup[];
}

export function TitlePageResultsAccordion({
  results,
}: TitlePageResultsAccordionProps): JSX.Element {
  return (
    <ExplorerResultsEntryAccordion>
      {_.map(results, (companyResult) => {
        return (
          <Accordion.Item value={companyResult.companyName} key={companyResult.companyId}>
            <Accordion.Control>
              <CompanyRangePercentile
                pl={0}
                pr={0}
                indentLevel={1}
                indentOffset={6}
                company={{
                  name: companyResult.companyName,
                  logoUrl:
                    companyResult.company.logoUrl ??
                    `https://logo.clearbit.com/${companyResult.companyName}.com`,
                }}
                resultsSummary={{
                  jobTitles: 0,
                  jobPosts: companyResult.posts.length,
                }}
                rangeLow={companyResult.salaryLow}
                rangeHigh={companyResult.salaryHigh}
              />
            </Accordion.Control>
            <Accordion.Panel>
              {_.map(companyResult.posts, (post) => (
                // @ts-expect-error TS2345
                <PostGeonameLink post={post} key={post.id} />
              ))}
            </Accordion.Panel>
          </Accordion.Item>
        );
      })}
    </ExplorerResultsEntryAccordion>
  );
}
